// extracted by mini-css-extract-plugin
export default {"navWrapper":"styles_navWrapper__7blHu","container":"styles_container__zgffs","navigation":"styles_navigation__E+uXI","active":"styles_active__L7A1F"};